import { useRef } from 'react';
import { Button, Flex, Icon, Table, Tbody, Td, Text, Th, Thead, Tr, useBreakpointValue } from '@chakra-ui/react';
import { BiPrinter } from 'react-icons/bi';
import { useReactToPrint } from 'react-to-print';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';

import { Container } from './styles';

interface ImpressaoParams {
	lancamento: FinJsonDTO;
}

const ImpressaoLancamento: React.FC<ImpressaoParams> = ({ lancamento }) => {
	const { company } = useAuth();

	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const handlePrint = useReactToPrint({
		bodyClass: "print-agreement",
		content: () => pdfRef.current,
	});

	const pdfRef = useRef<HTMLDivElement>(null);

	async function handleDate() {
		lancamento.data = format(new Date(lancamento.data), "dd'/'MM'/'yyyy", { locale: ptBR });

		lancamento.lancamentos.map(lanc => {
			if (lanc.data) {
				lanc.data = format(new Date(lanc.data), "dd'/'MM'/'yyyy", { locale: ptBR });
			}
			return lanc;
		});
	}

	/* useEffect(() => {
		handleDate();
	}, []); */

	return (
		<Container>
			<Button
				bg="transparent"
				_hover={{
					bg: isWideVersion ? "gray.50" : "gray.100"
				}}
				onClick={async () => {
					await handleDate();
					handlePrint();
				}}
			>
				<Icon as={BiPrinter} color="blue.500" w={5} h={5} />
			</Button>

			<Flex display="none">
				<Flex ref={pdfRef} px={2} py={4} w="100%" flexDir="column" align="center">
					<Text fontSize={13} fontWeight="bold">Recibo</Text>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Flex w="100%" px={1} flexDir="row" justifyContent="space-between">
						<Text fontSize={12} fontWeight="bold">NRO {lancamento.doc}</Text>
						<Text fontSize={12} fontWeight="bold">DATA {lancamento.data}</Text>
					</Flex>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Flex w="100%" flexDir="column" align="center">
						<Text fontSize={13} fontWeight="bold">{company.fantazia}</Text>
						<Text fontSize={13} fontWeight="bold">{company.endereco?.endereco}, {company.endereco?.num}</Text>
						<Text fontSize={13} fontWeight="bold">{company.fone}</Text>
					</Flex>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Flex w="100%" px={1} justify="flex-start">
						<Text fontSize={13}>CLIENTE {lancamento.cliente ? lancamento.cliente.id : '--'}</Text>
					</Flex>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Table w="100%" colorScheme="blackAlpha" size="sm">
						<Thead>
							<Tr>
								<Th fontSize={12} pl={1}>Venda</Th>
								<Th fontSize={12} px={0.5}>Data</Th>
								<Th isNumeric fontSize={12} pr={1}>Valor</Th>
							</Tr>
						</Thead>

						<Tbody py={1}>
							{lancamento.lancamentos.map(lanc => {
								return (
									<Tr key={lanc.id}>
										<Td fontSize={11} pl={1}>{lanc.id}</Td>
										<Td fontSize={11} px={0.5}>{lanc.data}</Td>
										<Td isNumeric fontSize={11} pr={1}>{lanc.vlr_cred > 0 ? formatPrice(lanc.vlr_cred) : formatPrice(lanc.vlr_deb)}</Td>
									</Tr>
								)
							})}
						</Tbody>
					</Table>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Flex w="100%" px={1} flexDir="column" justify="flex-start">
						<Text fontSize={11} fontWeight="bold">PAGAMENTO</Text>

						{lancamento.lancamentos.map(lanc => {
							return (
								<Flex key={lanc.id} w="100%" flexDir="row" justify="space-between">
									<Text fontSize={12}>{lanc.pay.name_pay}</Text>
									<Text fontSize={12}>{lanc.vlr_cred > 0 ? formatPrice(lanc.vlr_cred) : formatPrice(lanc.vlr_deb)}</Text>
								</Flex>
							)
						})}
					</Flex>

					<Flex w="100%" justify="center">
						<Text fontSize={11}>--------------------------------------------------------</Text>
					</Flex>

					<Flex w="100%" px={1} justify="flex-end">
						<Text fontSize={13} fontWeight="bold">VLR TOTAL {formatPrice(lancamento.vlr_doc)}</Text>
					</Flex>
				</Flex>
			</Flex>
		</Container>
	)
};

export default ImpressaoLancamento;
